"use client";

import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useRef } from "react";
import { setCatalogData, setCurrentPage } from "@/store/catalog/catalogSlice";

function CatalogPreloader({ data, url, page }) {
    const currentUrlRef = useRef(false);
    const dispatch = useDispatch();
    useEffect(() => {
        if (currentUrlRef.current !== url) {
            dispatch(setCatalogData(data));
            dispatch(setCurrentPage(page));
        }
    }, [url, data, page, currentUrlRef, dispatch])

    return null;
}

export default CatalogPreloader;